import { ref } from 'vue';
import { tsParticles } from '@tsparticles/engine';
import { loadConfettiPreset } from '@tsparticles/preset-confetti';

const useConfettiHook = () => {
  const tsParticlesElId = 'confetti';
  const tsParticlesContainer = ref(null);
  const intervalId = ref(null);

  const triggerConfetti = async () => {
    await loadConfettiPreset(tsParticles);

    try {
      tsParticlesContainer.value = await tsParticles.load({
        id: tsParticlesElId,  // it will create a new element with this id in the DOM
        options: {
          fullScreen: {
            zIndex: 10,
          },
          detectRetina: true,
          interactivity: {
            detectsOn: 'window',
            events: {
              onClick: {
                enable: true,
              },
              onHover: {
                enable: false,
              },
            },
          },
          particles: {
            color: {
              value: ['#FFFFFF'],
            },
            shape: {
              type: ['square'],
            },
            move: {
              speed: 30,
            },
          },
          emitters: [],
          preset: 'confetti',
        },
      });

      const tsParticlesEl = document.getElementById(tsParticlesElId);

      if (tsParticlesEl) {
        tsParticlesEl.style.pointerEvents = 'none';
      }

      const emittersPlugin = tsParticlesContainer.value.plugins.get('emitters');

      if (!emittersPlugin) {
        console.error('Emitters plugin not available');
        return;
      }

      const randomInRange = (min, max) => {
        return Math.random() * (max - min) + min;
      };

      const duration = 3 * 1000;
      const animationEnd = Date.now() + duration;

      intervalId.value = setInterval(() => {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          clearInterval(intervalId.value);
          return;
        }

        const particleCount = 50 * (timeLeft / duration);

        const commonEmitterProps = {
          rate: {
            quantity: particleCount,
            delay: 10.25,
          },
          life: {
            duration: 3,
            count: 1,
          },
          startCount: 60,
          autoPlay: true,
        };

        const emitterLeft = {
          ...commonEmitterProps,
          position: {
            x: randomInRange(0.1, 0.3) * 100,
            y: (Math.random() - 0.2) * 100,
          },
        };

        const emitterRight = {
          ...commonEmitterProps,
          position: {
            x: randomInRange(0.7, 0.9) * 100,
            y: (Math.random() - 0.2) * 100,
          },
        };

        emittersPlugin.addEmitter(emitterLeft);
        emittersPlugin.addEmitter(emitterRight);
      }, 250);
    } catch (error) {
      console.error({ message: 'error in triggerConfetti load', error });
    }
  };

  const clearConfetti = () => {
    clearInterval(intervalId.value);

    tsParticlesContainer.value.destroy();

    document.getElementById(tsParticlesElId)?.remove?.();
  };

  return {
    triggerConfetti,
    clearConfetti,
  };
};

export default useConfettiHook;
